module.exports = __webpack_public_path__ + "static/media/background.466b5e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.png
// module id = 79
// module chunks = 0